import * as React from 'react';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import muiTheme from 'cl-layout/theme';

const theme = createMuiTheme(muiTheme);

export default function LightTheme({children}) {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
